import { USER_CLICK_TRACK_ID } from '@thoughtspot/metrics';
import { ActionMenu, } from '@thoughtspot/radiant-react/widgets/action-menu';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { Popover } from '@thoughtspot/radiant-react/widgets/popover';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import styles from './more-options.module.scss';
export const MoreOptions = ({ menuId, menuLabel, menuItems = [], menuItemGroups = [], isDisabled = false, }) => {
    const [isActionMenuVisible, setIsActionMenuVisible] = useState(false);
    const onItemClick = (callBack) => {
        setIsActionMenuVisible(false);
        if (callBack) {
            callBack();
        }
    };
    const toggleActionMenu = () => {
        setIsActionMenuVisible(prevState => !prevState);
    };
    const parseActionItems = (items = menuItems) => {
        const menuItemsParsed = items.map((item) => {
            const modifiedItem = {
                ...item,
                onClick: () => {
                    onItemClick(item.onClick);
                },
            };
            return modifiedItem;
        });
        return menuItemsParsed;
    };
    const [parseMenuItems, setParsedMenuItems] = useState(parseActionItems());
    const popoverRef = useRef(null);
    const popperRef = useRef(null);
    const buttonRef = useRef(null);
    useEffect(() => {
        const handleDocumentKeyPress = (event) => {
            if (isActionMenuVisible && event.key === 'Escape') {
                setIsActionMenuVisible(false);
                buttonRef.current?.focus();
            }
        };
        document.addEventListener('keydown', handleDocumentKeyPress);
        return () => {
            document.removeEventListener('keydown', handleDocumentKeyPress);
        };
    }, [isActionMenuVisible]);
    let internalMenuItemGroups = [
        {
            title: menuLabel,
            items: parseMenuItems,
        },
    ];
    if (!_.isEmpty(menuItemGroups)) {
        internalMenuItemGroups = menuItemGroups.map((group) => ({
            ...group,
            items: parseActionItems(group.items),
        }));
    }
    const getActionMenu = () => (React.createElement(ActionMenu, { show: isActionMenuVisible, menuItemGroups: internalMenuItemGroups, "data-testid": `options_actionmenu${menuId}` }));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-tour-id": "user-management-tour", "data-testid": "user-management-tour" },
            React.createElement(Button, { onClick: toggleActionMenu, icon: IconID.MORE, type: "secondary", ariaLabel: menuLabel, "data-tooltip-content": menuLabel, "track-id": USER_CLICK_TRACK_ID.ELLIPSIS_ICON, "data-testid": `options_button${menuId}`, isDisabled: isDisabled, buttonRef: buttonRef })),
        React.createElement(Popover, { targetRef: buttonRef, align: "bottom-end", isVisible: isActionMenuVisible, popperRef: popperRef, content: getActionMenu(), className: styles.popoverContainer, onClickOutside: () => {
                setIsActionMenuVisible(false);
            } })));
};
//# sourceMappingURL=more-options.js.map